window.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia('(min-width: 750px)').matches) {
    return;
  }

  const handleFooterCollapse = (currentHeading) => {
    const allFooterHeadings = document.querySelectorAll('.grid .footer-block__heading.link-list');

    allFooterHeadings.forEach((heading) => {
      if (heading === currentHeading) {
        if (heading.classList.contains('block-collapsed')) {
          heading.classList.remove('block-collapsed');
          heading.setAttribute('aria-expanded', 'true');
        } else {
          heading.classList.add('block-collapsed');
          heading.setAttribute('aria-expanded', 'false');
        }
      } else {
        heading.classList.add('block-collapsed');
        heading.setAttribute('aria-expanded', 'false');
      }
    });
  };

  document.querySelectorAll('.grid .footer-block__heading.link-list').forEach((heading, index) => {
    heading.classList.add('block-collapsed');
    heading.setAttribute('role', 'button');
    heading.setAttribute('aria-expanded', 'false');
    heading.setAttribute('tabindex', '0');

    heading.nextElementSibling.setAttribute('id', `footer-block-index-${index}`);
    heading.setAttribute('aria-controls', `footer-block-index-${index}`);

    heading.addEventListener('click', () => {
      handleFooterCollapse(heading);
    });
    heading.addEventListener('keypress', () => {
      handleFooterCollapse(heading);
    });
  });
});